import { noUsersSaysVideoLocales } from '@elem/compPage/a-new-era-of-cool/config/pageConfig';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoButton from 'eco-design/base/eco-button';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoVideoItems from 'eco-design/sections/eco-video-items';
import { useRouter } from 'next/router';

import { useLang } from '@/i18n';
import styles from './index.module.scss';
import PartnerModal from '../PartnerModal';
import { useState } from 'react';

export default function Comp() {
    const { t } = useLang('theProduct.FreeGridSection');
    const { locale } = useRouter();
    const [modalVisible, setModalVisible] = useState(false);
    const itemsA = [
        {
            logoIcon: 'https://websiteoss.ecoflow.com/upload/image/1740990284875/user_avatar_1.png',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740990192290/users_saying_1.jpg',
            title: t('item1_title'),
            useName1: t('item1_name1'),
            useName2: t('item1_name2'),
            videoSrc: 'https://www.youtube.com/embed/MgJ3-Wr-q2I?si=VsL6ZmztZlIpxhyc',
        },
        {
            logoIcon: 'https://websiteoss.ecoflow.com/upload/image/1740990285251/user_avatar_2.png',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740990192664/users_saying_2.jpg',
            title: t('item2_title'),
            useName1: t('item2_name1'),
            useName2: t('item2_name2'),
            videoSrc: 'https://www.youtube.com/embed/EKJ-ivwfbMw?si=uX7WgM0Rh0db8IJx',
        },
        {
            logoIcon: 'https://websiteoss.ecoflow.com/upload/image/1740990285051/user_avatar_3.png',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740990192449/users_saying_3.jpg',
            title: t('item3_title'),
            useName1: t('item3_name1'),
            useName2: t('item3_name2'),
            videoSrc: 'https://www.youtube.com/embed/yZavrHJsBAw?si=xCammue97ivCgGPc',
        },
    ];

    const joinLinksMap = {
        us: 'https://www.facebook.com/groups/efoutdoor',
        ca: 'https://www.facebook.com/groups/efoutdoor',
        uk: 'https://www.facebook.com/groups/ecoflowuk',
        de: 'https://www.facebook.com/groups/ecoflowclubdeutsch',
        fr: 'https://www.facebook.com/groups/ecoflowfrancophone',
        it: 'https://www.facebook.com/groups/ecoflowit',
    };

    const joinLink = joinLinksMap[locale as keyof typeof joinLinksMap];

    const handleButtonClick = () => {
        setModalVisible(true);
    };

    const renderButton = () => {
        return (
            <EcoButton
                children={t('btn1')}
                onClick={handleButtonClick}
                lDataLayer={{
                    event: 'uaEvent',
                    event_name: 'click_pre_order',
                    product_name: 'EcoFlow Ocean Pro Be the First to Know_Free from the grid, for good.',
                }}
            />
        );
    };

    return (
        <div className={`${styles.comp}`}>
            <EcoSpaceSmall />
            <EcoSectionCommon
                sectionCommonLayout="left"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
                labelColor="#3F68E0"
                lChildren={renderButton()}
                // lHref={joinLink}
                // lDataLayer={{
                //     event: 'uaEvent',
                //     event_name: 'buy',
                //     product_name: 'none',
                //     position: 'Collections_Join Facebook Group',
                // }}
            />
            <EcoSpaceSmall />

            <PartnerModal visible={modalVisible} onClose={() => setModalVisible(false)} />
        </div>
    );
}
